import _ from "underscore";
import TableCell from "../../../table/TableCell";

function TabularDataTableCell()
{}

TabularDataTableCell.VALUE_VALID = 0;
TabularDataTableCell.VALUE_EMPTY = 1;
TabularDataTableCell.VALUE_INVALID = 2;

TabularDataTableCell.prototype = _.create(TableCell.prototype);

TabularDataTableCell.prototype.init = function( value, validator, rowObj )
{
    TableCell.call(this, value, rowObj);
    this.validator = validator;
    this.validationResult = TabularDataTableCell.VALUE_VALID;
    this.empty = validator.isEmpty( this );
    return this;
};

TabularDataTableCell.prototype.isValid = function()
{
    return this.validationResult == TabularDataTableCell.VALUE_VALID;
};

TabularDataTableCell.prototype.getValidationResult = function()
{
    return this.validationResult;
};

TabularDataTableCell.prototype.setValid = function()
{
    this.validationResult = TabularDataTableCell.VALUE_VALID;
};

TabularDataTableCell.prototype.setInvalid = function()
{
    this.validationResult = TabularDataTableCell.VALUE_INVALID;
};

TabularDataTableCell.prototype.isEmpty = function()
{
    return this.empty;
};

TabularDataTableCell.prototype.setValueNoValidate = function( value )
{
    TableCell.prototype.setValue.call( this, value );
};

TabularDataTableCell.prototype.setValue = function( value )
{
    this.setValueNoValidate( value );
    this.validate( true );
    if( this.onValueChangeCallBack )
        this.onValueChangeCallBack( this );
    this.getTable()._validationDetected();
};

TabularDataTableCell.prototype.validate = function( isEmptyValid )
{
    this.empty = this.validator.isEmpty( this );
    if( this.empty )
        this.validationResult = isEmptyValid ? TabularDataTableCell.VALUE_VALID : TabularDataTableCell.VALUE_EMPTY;
    else
        this.validationResult = this.validator.isValid( this ) ? TabularDataTableCell.VALUE_VALID : TabularDataTableCell.VALUE_INVALID;

    return this.isValid();
};

TabularDataTableCell.prototype.onChange = function( onValueChangeCallBack )
{
    this.onValueChangeCallBack = onValueChangeCallBack;
};

export default TabularDataTableCell;



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/TabularDataTableCell.js